import { MemberState } from '../state';
import { deleteFromLocalStorage } from '../../../../../utils';
import { LocalStorageKeys } from '../../../../../enums/local-storage-keys';

export const logoutMemberReducer = (state: MemberState) => {
  deleteFromLocalStorage(LocalStorageKeys.MEMBER_STATE);
  deleteFromLocalStorage(LocalStorageKeys.MEMBER_TOKEN);

  state.member = null;
  state.authedId = null;
  state.loggedIn = false;
};
